import { create } from "zustand";
import { geoData } from "../../../data/campusData";

const useGeoJsonStore = create(set => ({
  geoJson: geoData,
  setGeoJson: geoJson => set({ geoJson })
}));

export default useGeoJsonStore;
